import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { HOME_ROUTE } from './home.route';
import { HomeComponent } from './home.component';
import { JoyrideModule } from 'ngx-joyride';
import {NgxSplideModule} from "ngx-splide";

@NgModule({
    imports: [SharedModule, NgxSplideModule, RouterModule.forChild([HOME_ROUTE]), JoyrideModule.forChild()],
  declarations: [HomeComponent],
})
export class HomeModule {
}
